module.exports = __webpack_public_path__ + "static/media/V2_10.7956aab8.png";